<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="info-box">
        <div class="box-header with-border">
          <h3 class="box-title">Mixed List</h3>          
          
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <div class="row">
            <div class="col-md-6" v-if="canAccess('identity-proof-view-any')">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right"
                    ><button
                      v-if="canAccess('identity-proof-create')"
                      type="button"
                      class="btn btn-xs btn-success"
                      @click="newModalIdentity"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                  <h3 class="card-title">Identity Proof Details List</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                    :pagination-options="{
                      enabled: true,
                      perPage: 5,
                      perPageDropdown: [3, 7, 9],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'active'"
                          class="label label-success"
                          >Active</span
                        >
                        <span v-else class="label label-danger">InActive</span>
                      </span>
                      <span v-if="props.column.field == 'id'">
                        <button
                          v-if="canAccess('identity-proof-update')"
                          type="button"
                          @click="updateModalIdentity(props.row)"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6" v-if="canAccess('relation-view-any')">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right"
                    ><button
                      v-if="canAccess('relation-create')"
                      type="button"
                      class="btn btn-xs btn-success"
                      @click="newModalRelation"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                  <h3 class="card-title">Relation Details</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columns1"
                    :rows="rows1"
                    styleClass="vgt-table condensed"
                    :pagination-options="{
                      enabled: true,
                      perPage: 5,
                      perPageDropdown: [3, 7, 9],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'active'"
                          class="label label-success"
                          >Active</span
                        >
                        <span v-else class="label label-danger">InActive</span>
                      </span>
                      <span v-if="props.column.field == 'id'">
                        <button
                          v-if="canAccess('relation-update')"
                          type="button"
                          @click="updateModalRelation(props.row)"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
          </div>
          <div class="row">
            <div class="col-md-6" v-if="canAccess('purpose-view-any')">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right"
                    ><button
                      v-if="canAccess('purpose-view-any')"
                      type="button"
                      class="btn btn-xs btn-success"
                      @click="newModalPurpose"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                  <h3 class="card-title">Purpose Details</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columns2"
                    :rows="rows2"
                    styleClass="vgt-table condensed"
                    :pagination-options="{
                      enabled: true,
                      perPage: 5,
                      perPageDropdown: [3, 7, 9],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'active'"
                          class="label label-success"
                          >Active</span
                        >
                        <span v-else class="label label-danger">InActive</span>
                      </span>
                      <span v-if="props.column.field == 'id'">
                        <button
                          v-if="canAccess('purpose-view-any')"
                          type="button"
                          @click="updateModalPurpose(props.row)"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6" v-if="canAccess('reason-view-any')">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right"
                    ><button
                      v-if="canAccess('reason-view-any')"
                      type="button"
                      class="btn btn-xs btn-success"
                      @click="newModalReason"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                  <h3 class="card-title">Reason Details</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columns3"
                    :rows="rows3"
                    styleClass="vgt-table condensed"
                    :pagination-options="{
                      enabled: true,
                      perPage: 5,
                      perPageDropdown: [3, 7, 9],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'active'"
                          class="label label-success"
                          >Active</span
                        >
                        <span v-else class="label label-danger">InActive</span>
                      </span>
                      <span v-if="props.column.field == 'id'" class="align-center">
                        <button
                          v-if="canAccess('reason-view-any')"
                          type="button"
                          @click="updateModalReason(props.row)"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
          </div>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all 
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>



      
      <!-- /.row -->
      <div class="modal fade" id="newModalIdentity">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Add New Identity Proof</h4>
            </div>
            <form
              @submit.prevent="editMode ? updateIdentity() : createIdentity()"
            >
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Identity <span class="red">*</span></label>
                            <input
                              v-model="form.identity"
                              type="text"
                              name="identity"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('identity'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="identity"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option value="">Select Status View</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-primary"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-primary">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="newModalRelation">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Add New Relation Details</h4>
            </div>
            <form
              @submit.prevent="editMode ? updateRelation() : createRelation()"
            >
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Relation <span class="red">*</span></label>
                            <input
                              v-model="form.relation"
                              type="text"
                              name="relation"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('relation'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="relation"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option value="">Select Status View</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button v-show="!editMode" type="submit" class="btn btn-primary">CREATE</button>
                <button v-show="editMode" type="submit" class="btn btn-primary">UPDATE</button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="newModalPurpose">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Add New Purpose Details</h4>
            </div>
            <form
              @submit.prevent="editMode ? updatePurpose() : createPurpose()"
            >
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Purpose <span class="red">*</span></label>
                            <input
                              v-model="form.purpose"
                              type="text"
                              name="purpose"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('purpose'),
                              }"
                            />
                            <has-error :form="form" field="purpose"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option value="">Select Status View</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-primary"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-primary">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="newModalReason">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Add New Reason Details</h4>
            </div>
            <form @submit.prevent="editMode ? updateReason() : createReason()">
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Reason <span class="red">*</span></label>
                            <input
                              v-model="form.reason"
                              type="text"
                              name="reason"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('reason'),
                              }"
                            />
                            <has-error :form="form" field="reason"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option value="">Select Status View</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-primary"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-primary">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

</div>
</template>

<script>
export default {
  name: 'MixedMaster',
  data () {
    return {
      editMode: false,
      form: new Form({
        id: '',
        name: '',
        identity: '',
        relation: '',
        purpose: '',
        reason: '',
        status: ''
      }),
      columns: [
        {
          label: 'Identity',
          field: 'identity'
        },

        {
          label: 'Status',
          field: 'Status'
        },

        {
          label: 'Action',
          field: 'id',
          type: 'number'
        }
      ],
      columns1: [
        {
          label: 'Relation',
          field: 'relation'
        },

        {
          label: 'Status',
          field: 'Status'
        },

        {
          label: 'Action',
          field: 'id',
          type: 'number'
        }
      ],
      columns2: [
        {
          label: 'Purpose',
          field: 'purpose'
        },

        {
          label: 'Status',
          field: 'Status'
        },

        {
          label: 'Action',
          field: 'id',
          type: 'number'
        }
      ],
      columns3: [
        {
          label: 'Reason',
          field: 'reason'
        },

        {
          label: 'Status',
          field: 'Status'
        },

        {
          label: 'Action',
          field: 'id',
          type: 'number'
        }
      ],
      rows: [],
      rows1: [],
      rows2: [],
      rows3: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModalIdentity () {
      this.editMode = false
      this.form.reset()
      $('#newModalIdentity').modal({backdrop: 'static', keyboard: false})
    },
    newModalRelation () {
      this.editMode = false
      this.form.reset()
      $('#newModalRelation').modal({backdrop: 'static', keyboard: false})
    },
    newModalPurpose () {
      this.editMode = false
      this.form.reset()
      $('#newModalPurpose').modal({backdrop: 'static', keyboard: false})
    },
    newModalReason () {
      this.editMode = false
      this.form.reset()
      $('#newModalReason').modal({backdrop: 'static', keyboard: false})
    },
    updateModalIdentity (row) {
      this.editMode = true
      this.form.reset()
      $('#newModalIdentity').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    updateModalRelation (row) {
      this.editMode = true
      this.form.reset()
      $('#newModalRelation').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    updateModalPurpose (row) {
      this.editMode = true
      this.form.reset()
      $('#newModalPurpose').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    updateModalReason (row) {
      this.editMode = true
      this.form.reset()
      $('#newModalReason').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    createIdentity () {
      this.$axios
        .post('identity', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreateIdentity')
          $('#newModalIdentity').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Identity Proof Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    createRelation () {
      this.$axios
        .post('relation', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreateRelation')
          $('#newModalRelation').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Relation Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    createPurpose () {
      this.$axios
        .post('purpose', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreatePurpose')
          $('#newModalPurpose').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Purpose Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    createReason () {
      this.$axios
        .post('reason', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreateReason')
          $('#newModalReason').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Reason Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateIdentity () {
      this.$axios
        .put('identity/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreateIdentity')
          $('#newModalIdentity').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateRelation () {
      this.$axios
        .put('relation/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreateRelation')
          $('#newModalRelation').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updatePurpose () {
      this.$axios
        .put('purpose/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreatePurpose')
          $('#newModalPurpose').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateReason () {
      this.$axios
        .put('reason/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreateReason')
          $('#newModalReason').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadIdentity () {
      let loader = this.$loading.show()
      this.$axios
        .get('identity?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          loader.hide()
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadRelation () {
      let loader = this.$loading.show()
      this.$axios
        .get('relation?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          loader.hide()
          this.rows1 = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadPurpose () {
      let loader = this.$loading.show()
      this.$axios
        .get('purpose?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          loader.hide()
          this.rows2 = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadReason () {
      let loader = this.$loading.show()
      this.$axios
        .get('reason?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          loader.hide()
          this.rows3 = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadIdentity()
    this.loadRelation()
    this.loadPurpose()
    this.loadReason()
    Fire.$on('AfterCreateIdentity', () => {
      this.loadIdentity()
    })
    Fire.$on('AfterCreateRelation', () => {
      this.loadRelation()
    })
    Fire.$on('AfterCreatePurpose', () => {
      this.loadPurpose()
    })
    Fire.$on('AfterCreateReason', () => {
      this.loadReason()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>




// WEBPACK FOOTER //
// MixedMaster.vue?1aaafbf7